import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCompactMoney } from '@/lib/money';

export type TopCreatorView = {
  userId: number;
  displayName: string;
  username?: string;
  avatarUrl?: string;
  amount: number;
};

export function TopCreatorsCard({
  creators,
  currency,
}: {
  creators: TopCreatorView[];
  currency: string;
}) {
  return (
    <Card className="overflow-hidden bg-card/80 shadow-none">
      <CardHeader className="p-4 pb-2">
        <CardTitle className="text-sm font-medium text-sky-400">Top Creators</CardTitle>
        <p className="text-[11px] text-muted-foreground">Top 5 by Creator Earnings</p>
      </CardHeader>
      <CardContent className="p-0">
        {creators.length === 0 ? (
          <p className="px-4 py-3 text-xs text-muted-foreground">
            No creator payouts for this period.
          </p>
        ) : (
          <ul className="divide-y">
            {creators.map((creator, index) => {
              const initial = (creator.displayName || creator.username || '?')
                .charAt(0)
                .toUpperCase();
              return (
                <li
                  key={creator.userId}
                  className="flex items-center justify-between gap-3 px-4 py-2.5 text-xs"
                >
                  <span className="flex min-w-0 items-center gap-2">
                    <span className="w-4 shrink-0 text-muted-foreground">{index + 1}</span>
                    <Avatar className="size-7">
                      {creator.avatarUrl ? (
                        <AvatarImage src={creator.avatarUrl} alt={creator.displayName} />
                      ) : null}
                      <AvatarFallback className="text-[10px]">{initial}</AvatarFallback>
                    </Avatar>
                    <span className="min-w-0">
                      <span className="block truncate font-medium">{creator.displayName}</span>
                      {creator.username ? (
                        <span className="block truncate text-[10px] text-muted-foreground">
                          @{creator.username}
                        </span>
                      ) : null}
                    </span>
                  </span>
                  <span className="shrink-0 tabular-nums font-medium">
                    {formatCompactMoney(creator.amount, currency)}
                  </span>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
